/**
 * Interactive confirmation prompt.
 *
 * Writes prompt to stderr, reads answer from stdin.
 * Returns true if the user answers "y" or "yes" (case-insensitive).
 *
 * In non-interactive mode (--no-input flag or ELECTRIC_API_TOKEN set),
 * returns false immediately — callers should check {@link isInteractive}
 * and fail with a message directing the user to pass --force.
 */

import { createInterface } from 'node:readline'

let _noInput = false

export function setNoInput(value: boolean): void {
  _noInput = value
}

/**
 * Returns true if the CLI is running in interactive mode.
 * Non-interactive when --no-input is passed or ELECTRIC_API_TOKEN is set.
 */
export function isInteractive(): boolean {
  if (_noInput) return false
  if (process.env.ELECTRIC_API_TOKEN) return false
  return true
}

export function confirm(prompt: string): Promise<boolean> {
  if (!isInteractive()) {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    const rl = createInterface({
      input: process.stdin,
      output: process.stderr,
    })
    rl.question(prompt, (answer) => {
      rl.close()
      resolve(answer.toLowerCase() === `y` || answer.toLowerCase() === `yes`)
    })
  })
}
